import React from 'react';
import PropTypes from 'prop-types';

import { Modal, ModalBody, ModalFooter } from '@vds/modals';

import { isMobile } from '../../Helpers';
import { timeoutLabels } from '../label';

import SessionModalContent from '../SessionModalContent';
import SessionModalFooter from '../SessionModalFooter';

const SessionTimeoutExisting = (props) => {
  let title;
  let description;
  let buttonText;
  if (props.sessionTimedOut) {
    title = timeoutLabels.timeoutHeaderAAL;
    description = timeoutLabels.timeoutMessageAAL;
    buttonText = timeoutLabels.logInCTA;
  } else {
    title = timeoutLabels.warningHeaderAAL;
    description = timeoutLabels.warningMessageAAL.replace('#TimeLeft#', props.timeLeft);
    buttonText = timeoutLabels.continueCTA;
  }

  const isMobileDevice = isMobile();

  return (
    <Modal opened={props.isOpen} closeButton={null} disableOutsideClick>
      <ModalBody>
        <SessionModalContent {...props} title={title} description={description} buttonText={buttonText} isMobileDevice={isMobileDevice} />
      </ModalBody>
      {isMobileDevice && (
        <ModalFooter>
          <SessionModalFooter {...props} buttonText={buttonText} />
        </ModalFooter>
      )}
    </Modal>
  );
};

SessionTimeoutExisting.propTypes = {
  isOpen: PropTypes.bool,
  sessionTimedOut: PropTypes.bool,
  timeLeft: PropTypes.string,
};

export default SessionTimeoutExisting;
